/* unplugin-vue-components disabled */import { render } from "./PlanDetail.vue?vue&type=template&id=2dee9fea&scoped=true&ts=true"
import script from "./PlanDetail.vue?vue&type=script&lang=ts"
export * from "./PlanDetail.vue?vue&type=script&lang=ts"

import "./PlanDetail.vue?vue&type=style&index=0&id=2dee9fea&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dee9fea"]])

export default __exports__